import React from 'react';

import { useGraphQLMutation } from '@betterment/graphql';
import { Button } from '@betterment/samba-react';
import * as Sentry from '@sentry/browser';

import { OutboundIntegration } from '../../../graphql/schema';
import { UpdateFirmIntegrationSubscriptionStatusDocument } from '../graphql/mutation.firmSubscription.generated';

const IntegrationConnectButton: React.FC<{
  saveHandler: () => void;
  integration: OutboundIntegration;
}> = ({ saveHandler, integration }) => {
  const [subscribeFirm, { loading }] = useGraphQLMutation(UpdateFirmIntegrationSubscriptionStatusDocument);

  return (
    <Button
      data-testid="connectModalConnectButton"
      variant="solidPrimary"
      css={{ mt: 'space.400' }}
      onClick={() => {
        subscribeFirm({
          variables: {
            input: {
              id: integration.id,
              isSubscribed: true,
            },
          },
        })
          .then(() => {
            saveHandler();
          })
          .catch(err => {
            Sentry.captureException(err);
          });
      }}
      loading={loading}
    >
      Connect to {integration.name}
    </Button>
  );
};

export default IntegrationConnectButton;
